import { render, staticRenderFns } from "./ModalAcademyRequestService.vue?vue&type=template&id=53af682a&scoped=true&lang=pug&"
import script from "./ModalAcademyRequestService.vue?vue&type=script&lang=ts&"
export * from "./ModalAcademyRequestService.vue?vue&type=script&lang=ts&"
import style0 from "./ModalAcademyRequestService.vue?vue&type=style&index=0&id=53af682a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53af682a",
  null
  
)

export default component.exports